import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function YachtImageSlider({ images, yachtName }) {
    const [isImageError, setIsImageError] = useState({});

    // Resim URL'ini oluşturan yardımcı fonksiyon
    const getImageUrl = (image) => {
        // Eğer image bir obje ise (yachtImages formatı)
        if (typeof image === 'object' && image.imageUrl) {
            return `https://cyprusyachtclub.com/rest-images/YachtImages/${image.imageUrl}`;
        }
        // Eğer image bir string ise (eski format için backward compatibility)
        return image;
    };

    // Eğer resim yoksa veya boş array ise placeholder göster
    if (!images || images.length === 0) {
        return (
            <div className="w-full h-full bg-gradient-to-br from-blue-600/20 to-blue-800/20 flex items-center justify-center">
                <div className="text-center text-white/60">
                    <svg className="w-16 h-16 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M3 13h1l1 2h2l1-2h2l1 2h2l1-2h2l1 2h2l1-2h2l1 2h1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1z"/>
                        <path d="M12 2l-1 3v6h2V5l-1-3zm4 8l-1-3v6h2V8l-1-2zm-8 0l-1-2v4h2V8l-1-2z"/>
                        <path d="M12 10v3"/>
                    </svg>
                    <p className="text-sm">{yachtName}</p>
                </div>
            </div>
        );
    }

    // Slider ayarları
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        arrows: true,
        customPaging: function(i) {
            return (
                <div className="w-2 h-2 bg-white/30 rounded-full hover:bg-white/60 transition-colors duration-200"></div>
            );
        },
        dotsClass: "slick-dots yacht-card-dots",
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />
    };

    const handleImageError = (index) => {
        setIsImageError(prev => ({
            ...prev,
            [index]: true
        }));
    };

    return (
        <div className="yacht-image-slider relative w-full h-full overflow-hidden rounded-t-2xl">
            <Slider {...settings}>
                {images.map((image, index) => {
                    const imageKey = typeof image === 'object' && image.id ? image.id : index;
                    return (
                        <div key={imageKey} className="relative w-full h-full">
                            {!isImageError[index] ? (
                                <img
                                    src={getImageUrl(image)}
                                    alt={`${yachtName} - ${index + 1}`}
                                    className="w-full h-full object-cover"
                                    onError={() => handleImageError(index)}
                                    loading="lazy"
                                />
                            ) : (
                            // Resim yüklenemezse placeholder göster
                            <div className="w-full h-full bg-gradient-to-br from-blue-600/20 to-blue-800/20 flex items-center justify-center">
                                <div className="text-center text-white/60">
                                    <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M3 13h1l1 2h2l1-2h2l1 2h2l1-2h2l1 2h2l1-2h2l1 2h1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1z"/>
                                        <path d="M12 2l-1 3v6h2V5l-1-3zm4 8l-1-3v6h2V8l-1-2zm-8 0l-1-2v4h2V8l-1-2z"/>
                                        <path d="M12 10v3"/>
                                    </svg>
                                    <p className="text-xs">Resim Yüklenemedi</p>
                                </div>
                            </div>
                                                    )}
                        </div>
                    );
                })}
            </Slider>
            
            {/* Resim sayısı göstergesi */}
            <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm rounded-full px-2 py-1 text-white text-xs font-medium">
                {images.length} foto
            </div>
        </div>
    );
}

// Özel ok bileşenleri
function CustomPrevArrow(props) {
    const { onClick } = props;
    return (
        <button
            onClick={onClick}
            className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-black/30 hover:bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
        >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
        </button>
    );
}

function CustomNextArrow(props) {
    const { onClick } = props;
    return (
        <button
            onClick={onClick}
            className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-black/30 hover:bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
        >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
        </button>
    );
}

export default YachtImageSlider;